import type { FieldLLMConfig } from '../types/schema';

export function formatLlmInstructions(llm: FieldLLMConfig): string {
  const parts: string[] = [];

  if (llm.description) {
    parts.push(`Description: ${llm.description}`);
  }
  if (llm.notes) {
    parts.push(`Notes: ${llm.notes}`);
  }
  if (llm.format) {
    parts.push(`Format: ${llm.format}`);
  }
  if (llm.examples_valid && llm.examples_valid.length > 0) {
    parts.push(`Exemples valides: ${llm.examples_valid.join(', ')}`);
  }
  if (llm.examples_invalid && llm.examples_invalid.length > 0) {
    parts.push(`Exemples invalides: ${llm.examples_invalid.join(', ')}`);
  }
  if (llm.search_terms && llm.search_terms.length > 0) {
    parts.push(`Termes de recherche: ${llm.search_terms.join(', ')}`);
  }
  if (llm.allowed_values && llm.allowed_values.length > 0) {
    parts.push(`Valeurs permises: ${llm.allowed_values.join(', ')}`);
  }

  return parts.join('\n');
}
